module.exports = __webpack_public_path__ + "fonts/Calibre-SemiboldItalic.6473be72.woff";